export const DEFAULT_CALENDAR = {
  events: [],
  headerToolbar: {
    left: 'prev,next today',
    center: 'title',
    right: 'dayGridMonth,timeGridWeek,timeGridDay'
  },
  initialView: 'timeGridWeek',
  editable: true,
  selectable: true,
  selectMirror: true,
  dayMaxEvents: true,
  weekends: true,
  customButtons: {
    next: {
      text: 'next',
      click: () => {
        let calendarApi = this.eventsCalendar.getApi()
        calendarApi.next()
        this.loadEvents(calendarApi.view)
      }
    },
    prev: {
      text: 'prev',
      click: () => {
        let calendarApi = this.eventsCalendar.getApi()
        calendarApi.prev()
        this.loadEvents(calendarApi.view)
      }
    },
    dayGridMonth: {
      text: 'Month',
      click: () => {
        console.log('month')
        let calendarApi = this.eventsCalendar.getApi()
        //calendarApi.prev()
        calendarApi.changeView('dayGridMonth')
        this.loadEvents(calendarApi.view)
      }
    }
  }
}

export const STATUSES = [
  {
    id: 1,
    name: 'Pending'
  },
  {
    id: 2,
    name: 'Confirmed'
  },
  {
    id: 3,
    name: 'Cancelled'
  },
  {
    id: 4,
    name: 'Potential'
  }
]

export const PHONE_FORMAT = /^(\([2-9]{1}[0-9]{2}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/
// eslint-disable-next-line no-useless-escape
//export const PHONE_FORMAT = /^[+]*[(]{0,1}[1-9]{1,4}[)]{0,1}[-\s\./0-9]*$/

export const validatePhone = val => {
  return PHONE_FORMAT.test(val)
}

export const REPEAT_OPTIONS = [
  {
    name: 'Does not repeat',
    config: null
  },
  {
    name: 'Weakly (Mon- Fry)',
    config: {
      times: 1,
      each: 'week',
      selectedDays: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      endAt: 'never'
    }
  },
  {
    name: 'Custom',
    config: {
      each: 'day',
      selectedDays: [],
      endAt: 'never'
    }
  }
]
export const REPEAT_TIME_OPTIONS = ['day', 'week', 'month', 'year']
export const DAYS_OF_WEEK = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday'
]

export const DEFAULT_EVENT = {
  title: '',
  backgroundColor: '',
  borderColor: '',
  textColor: '',
  classNames: [],
  incall: false,
  rate_type_id: null,
  constraint: null,
  startEditable: null,
  durationEditable: null,
  groupId: null,
  overlap: true,
  source: null,
  event_type_id: 2,
  start_date: null,
  end_date: null,
  start_hour: '',
  end_hour: '',
  comment: null,
  reminder: null,
  reminder_config: 'email,5,minutes',
  allDay: false,
  url: null,
  new: true,
  user_id: null,
  address: null,
  location_url: '',
  country: null,
  latitude: null,
  longitude: null,
  locality: null,
  street_number: null,
  postal_code: null,
  status_id: null,
  address2: null,
  fees: {
    cost: 0,
    transport: 0,
    miscellaneous: 0,
    cash: 0,
    credit: 0
  },
  repeat: {
    name: 'Does not repeat',
    config: null
  },
  addresses: [],
  google_address: {}
}
